export default __webpack_public_path__ + "9ec36a73e4f25a9a96f4a25836f3f6ba.png";